import React, {
  ReactNode,
} from 'react';
import MuiPopover, {
  PopoverOrigin,
  PopoverProps as MuiPopoverProps,
} from '@mui/material/Popover';
import isNil from 'lodash/isNil';
import clsx from 'clsx';

export type Props = Omit<MuiPopoverProps, 'open'> & {
  children?: ReactNode;
  paperClasses?: string;
  onClose?: () => void;
};

const defaultOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export default function Popover({
  children,
  onClose,
  anchorEl,
  disableScrollLock = true,
  disableAutoFocus = false,
  disableEnforceFocus = false,
  disableRestoreFocus = false,
  anchorOrigin = defaultOrigin,
  transformOrigin = defaultOrigin,
  paperClasses,
  ...props
}: Props) {
  return (
    <MuiPopover
      {...props}
      open={!isNil(anchorEl)}
      onClose={onClose}
      disableScrollLock={disableScrollLock}
      disableAutoFocus={disableAutoFocus}
      disableEnforceFocus={disableEnforceFocus}
      disableRestoreFocus={disableRestoreFocus}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      classes={{
        paper: clsx('!overflow-y-visible !overflow-x-visible', paperClasses),
      }}
    >
      {children}
    </MuiPopover>
  );
}
